import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import resourceIllustration from '../../../../../../assets/images/schedule_resource_illustration.svg';
import FormLoader from '../../../../common/FormLoader';
import * as common from '../../../../common/__redux/commonRedux';
import CustomToast from '../../../../common/CustomToast';
import { createPois, updatePois, getPoi } from '../networking';
import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import ConfirmationModal from '../../../../common/ConfirmationModal';
import jsonData from '../dummyData.json'
import CustomCheckbox from "../../../../common/CustomCheckbox";

const PoisCrudForm = ({ type, showDialog, setShowDialog, poiSaveEvent, editId }) => {
    const dictionary = useDictionary();
    const [showDialogAnimation, setShowDialogAnimation] = useState(false);
    const [showLoaderMessage, setShowLoaderMessage] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [poiPlaceId, setPoiPlaceId] = useState('');
    const [poiNameValue, setPoiNameValue] = useState('');
    const [poiInputValue, setPoiInputValue] = useState('');
    const [poiMatchedValue, setPoiMatchedValue] = useState(0);
    const [poiForceUpdateValue, setPoiForceUpdateValue] = useState(0);
    // const [poiStatusValue, setPoiStatusValue] = useState('');
    const [enableCreating, setEnableCreating] = useState(false);
    const [showDismissDialog, setDismissDialogVisibility] = useState(false);
    const [prevDataObject, setPrevDataObject] = useState({});
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        setPrevDataObject({
            placeId: '',
            name: '',
            matched: 0,
            force_update: 0,
            status: '',
        });
        if (type === 'edit') {
            getPoiInfo();
        }
    }, []);

    useEffect(() => {
        setShowDialogAnimation(true);
        setEnableCreating(true);
    }, [showDialog]);

    const getPoiInfo = async () => {
        setShowLoader(true);
        try {
            //Get Request here
            let { data } = await getPoi(editId);
            // let data = jsonData.find(poi => poi.id === editId);
            if (data.data) {
                setPoiPlaceId(data.data.place_id || '');
                setPoiNameValue(data.data.name || '');
                setPoiInputValue(data.data.input || '');
                setPoiMatchedValue(data.data.matched || 0);
                setPoiForceUpdateValue(data.data.force_update || 0);
                setPrevDataObject({
                    placeId: data.data.place_id,
                    name: data.data.name,
                    input: data.data.input,
                    matched: data.data.matched,
                    force_update: data.data.force_update
                });
            }
            setShowLoader(false);
        } catch (e) {
            setShowLoader(false);
        }
    };

    const handleInputChange = (setter) => (event) => {
        setter(event.target.value);
    };

    const dismissDialog = () => {
        const currentData = {
            placeId: poiPlaceId,
            name: poiNameValue,
            input: poiInputValue,
            matched: poiMatchedValue,
            force_update: poiForceUpdateValue
        };

        if (JSON.stringify(prevDataObject) === JSON.stringify(currentData)) {
            setShowDialogAnimation(false);
            setTimeout(() => {
                setShowDialog(false);
            }, 600);
        } else {
            setDismissDialogVisibility(true);
        }
    };

    const dismissDialogBox = () => {
        setShowDialogAnimation(false);
        setTimeout(() => {
            setShowDialog(false);
        }, 600);
    };

    const onFinishClicked = () => {
        if (type === 'edit') {
            updateGroup();
        } else {
            createGroup();
        }
    };

    const updateGroup = async () => {
        setShowLoader(true);
        setEnableCreating(false);
        if (poiPlaceId) {
            try {
                let body = {
                    // Allow only match and force update changes
                    // placeId: poiPlaceId,
                    // name: poiNameValue,
                    // input: poiInputValue,
                    matched: poiMatchedValue,
                    force_update: poiForceUpdateValue
                };
                await updatePois(editId, body);
                setShowLoader(false);
                poiSaveEvent(true);
                dismissDialog();
            } catch (e) {
                handleApiError(e);
            }
        }
    };

    const createGroup = async () => {
        setShowLoader(true);
        setEnableCreating(false);
        if (poiPlaceId) {
            try {
                let body = {
                    placeId: poiPlaceId,
                    name: poiNameValue,
                    input: poiInputValue,
                    matched: poiMatchedValue,
                    force_update: poiForceUpdateValue
                    // status: poiStatusValue
                };
                const { data } = await createPois(body);
                setShowLoader(false);
                poiSaveEvent(data);
                dismissDialog();
            } catch (e) {
                handleApiError(e);
            }
        }
    };

    const handleApiError = (e) => {
        setEnableCreating(true);
        setShowLoader(false);
        if (e?.response?.data?.message) {
            toast.error(<CustomToast message={e.response.data.message} />, {
                position: 'bottom-left',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                closeButton: false,
                icon: false,
                className: 'toast-white-error'
            });
        }
    };

    useEffect(() => {
        setEnabled(
            poiPlaceId?.trim() !== '' &&
            poiNameValue?.trim() !== '' &&
            poiInputValue?.trim() !== ''
            // poiStatusValue?.trim() !== ''
        );
    }, [poiPlaceId, poiNameValue, poiInputValue]);

    return (
        <div className={`group-category-tags-wrapper${showDialogAnimation ? ' group-category-tags-wrapper-visible' : ''}`} style={{ zIndex: 11 }}>
            <div className="group-dialog-content-wrapper thin-scrollbar">
                <div className="dialog-close-button" style={{ right: '24px', top: '24px' }} onClick={dismissDialog} />
                <img src={resourceIllustration} />
                <div className="group-dialog-content-container group-dialog-content-form-container">
                    <h2 style={{ whiteSpace: 'pre-line', marginBottom: 32, lineHeight: '24px' }}>
                        {type === 'create' ? dictionary.add_new_poi : dictionary.edit_poi}
                    </h2>
                    <div className="group-inputs text-name-wrapper">
                        <label>{dictionary.Poi_Place_Id}</label>
                        <input type="text" maxLength="255" value={poiPlaceId} onChange={handleInputChange(setPoiPlaceId)} />
                    </div>
                    <div className="group-inputs text-name-wrapper">
                        <label>{dictionary.Poi_Name}</label>
                        <input type="text" maxLength="255" value={poiNameValue} onChange={handleInputChange(setPoiNameValue)} />
                    </div>
                    <div className="group-inputs text-name-wrapper">
                        <label>{dictionary.Poi_Input}</label>
                        <input type="text" maxLength="255" value={poiInputValue} onChange={handleInputChange(setPoiInputValue)} />
                    </div>
                    <div className="group-inputs text-name-wrapper">
                        <CustomCheckbox
                            checked={["1", 1, true].includes(poiMatchedValue)} // Normalize to boolean
                            setChecked={setPoiMatchedValue}
                            type={1}
                            label={dictionary.Poi_Matched}
                        />
                    </div>
                    <div className="group-inputs text-name-wrapper">
                        <CustomCheckbox
                            checked={["1", 1, true].includes(poiForceUpdateValue)} // Normalize to boolean
                            setChecked={setPoiForceUpdateValue}
                            type={1}
                            label={dictionary.Poi_Force_Update}
                        />
                    </div>


                    {/* <div className="group-inputs text-name-wrapper">
                        <label>{dictionary.Poi_Matched}</label>
                        <input type="text" maxLength="255" value={poiMatchedValue} onChange={handleInputChange(setPoiMatchedValue)} />
                    </div>
                    <div className="group-inputs text-name-wrapper">
                        <label>{dictionary.Poi_Status}</label>
                        <input type="text" maxLength="255" value={poiStatusValue} onChange={handleInputChange(setPoiStatusValue)} />
                    </div> */}
                </div>
            </div>
            <FormLoader
                onDismissClicked={dismissDialog}
                showMessage={showLoaderMessage}
                message={loaderMessage}
                rounded
                showLoader={showLoader}
                showEnter={false}
            />
            <div className="group-dialog-button-container">
                <button disabled={!enableCreating} onClick={enabled ? onFinishClicked : null} className={enabled ? 'button' : 'button button-disabled'}>
                    {dictionary.save}
                </button>
            </div>
            {showDismissDialog && (
                <ConfirmationModal
                    setShowModal={setDismissDialogVisibility}
                    asyncTask={dismissDialogBox}
                    title={dictionary.dismiss_dialog}
                    action={dictionary.dismiss}
                />
            )}
        </div>
    );
};

PoisCrudForm.propTypes = {
    type: PropTypes.string,
    showDialog: PropTypes.bool,
    setShowDialog: PropTypes.func,
    poiSaveEvent: PropTypes.func,
    editId: PropTypes.string
};

export default connect(common.states, common.actions)(PoisCrudForm);